/**
 * Shared picking-list filter helpers.
 *
 * Kept here (module scope, no React) so both the list view (ModernPickingList)
 * and the "Nästa plock" dispatcher (ModernPickingApp) use one source of truth.
 */

// Device-local key for the "due today or overdue" availability filter
// (persisted per tablet — no DB / SettingDefinition involved).
export const DELIVERY_TODAY_FILTER_KEY = 'bizclick_picking_delivery_today_filter';

/**
 * True if the picking list is due today or earlier (overdue).
 * Picks without a delivery date are treated as "not due today" and are hidden
 * while the filter is on. Comparison is by calendar day in local time, so a
 * delivery timestamp anywhere within today still counts as today.
 */
export const isDueTodayOrEarlier = (deliveryDate?: string | null): boolean => {
  if (!deliveryDate) return false;
  const d = new Date(deliveryDate);
  if (isNaN(d.getTime())) return false;
  const today = new Date();
  const deliveryDay = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  return deliveryDay <= todayDay;
};
